import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { fork, take } from 'redux-saga/effects';

import { QueryAction, QueryGenerator, QueryParams } from '../types';

import { isStatusUnknown, QueryContext } from './QueryContext';

export function takeEveryAction<P, Q = any>(
  sliceAction: ActionCreatorWithPayload<QueryParams<P, Q>>,
  generator: QueryGenerator<P, Q>,
) {
  return fork(function* () {
    while (true) {
      const action: unknown = yield take(sliceAction.type);
      const { payload = {} as QueryParams<P, Q> } = action as QueryAction<P, Q>;

      if (isStatusUnknown(payload?.status)) {
        const ctx = new QueryContext(sliceAction, payload) as any;
        yield fork(generator, ctx);
      }
    }
  });
}
